import { PlusOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { DESC, ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import React, { useEffect, useState } from 'react';
import { getPaginationState, log } from 'react-jhipster';
import { useLocation } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Form, Input, Modal, Row, Select, Tooltip } from 'antd';
import Title from 'antd/es/typography/Title';
import { setListFilterApprovalLevel } from 'app/entities/filters/filters.reducer';
import ModalConfirmComponent from 'app/shared/component/modal/confirm';
import TableComponent from 'app/shared/component/table/table';
import * as _ from 'lodash';
import { deleteEntity, getAdjustmentConfigure, getApproveConfigure, getEntities, getTypeSelectboxApprovalLevel, reset } from '../approval-level.reducer';
import ApprovalLevelUpdate from '../form/approval-level';
import { columns } from './config';
import { getCurrentStatusProcess, getCurrentStatusProcessAdjustment } from './modal/category-approve.reducer';
import { filterOption } from 'app/shared/util/select-filter';

const { Search } = Input;
type IApproveModal = {
  isOpen: boolean,
  onClose: () => void,
}

export const ApprovalLevel = ({ isOpen, onClose }: IApproveModal) => {
  const dispatch = useAppDispatch();
  const pageLocation = useLocation();
  const [form] = Form.useForm();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'lastModifiedDate', DESC), pageLocation.search),
  );

  const filtersObjective = useAppSelector(state => state.filters.objective);
  const filters = useAppSelector(state => state.filters.approvalLevel);
  const planPeriodList = useAppSelector(state => state.planPeriod.entities);
  const approvalLevelList = useAppSelector(state => state.approvalLevel.entities);
  const isLoading = useAppSelector(state => state.approvalLevel.loading);
  const isDeleting = useAppSelector(state => state.approvalLevel.updating);
  const currentStatusProcess = useAppSelector(state => state.categoryApprove.entity);
  const currentStatusProcessAdjustment = useAppSelector(state => state.categoryApprove.entityAdjustment);
  const typeSelectboxData = useAppSelector(state => state.approvalLevel.typeSelectbox);
  const adjustmentConfigure = useAppSelector(state => state.approvalLevel.adjustmentConfigure);
  const approveConfigure = useAppSelector(state => state.approvalLevel.approveConfigure);
  const loadingAdjustmentConfigure = useAppSelector(state => state.approvalLevel.loadingAdjustmentConfigure);
  const loadingApproveConfigure = useAppSelector(state => state.approvalLevel.loadingApproveConfigure);
  const [selectedPlanPeriod, setSelectedPlanPeriod] = useState(null);
  const [planPeriodIdSelected, setPlanPeriodIdSelected] = useState(null);
  const [isDisabledAdd, setIsDisabledAdd] = useState(false);


  const [visibleConfirmDelete, setVisibleConfirmDelete] = useState(false);
  const [isOpenForm, setOpenForm] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);

  // config columns, actions add plan period
  const newColumns = [
    ...columns,
    {
      title: 'Hành động',
      key: 'Action',
      fixed: 'right',
      width: 80,
      render: (item: any) => {
        const isFinished = currentStatusProcessAdjustment ? currentStatusProcessAdjustment?.isFinished : currentStatusProcess?.isFinished;
        return (
          !isFinished &&
          (
            <div className="action">
              <span className="action-edit">
                <Tooltip title="Sửa">
                  <FontAwesomeIcon onClick={() => {
                    handleOpenForm(item);
                  }} icon="pencil-alt" />
                </Tooltip>
              </span>
              <span className="action-delete">
                <Tooltip title="Xóa">
                  <FontAwesomeIcon
                    onClick={() => {
                      handleWarningDeleteItem(item);
                    }}
                    icon="trash"
                  />
                </Tooltip>
              </span>
            </div>
          )
        )
      }
    },
  ];

  // end config

  useEffect(() => {
    dispatch(setListFilterApprovalLevel({ ...filtersObjective }))
  }, [filtersObjective]);

  // useEffect(() => {
  //   if (filters?.accountableId) {
  //     handleFetCurrentStatusProcess()
  //   }
  // }, [filters]);

  const getAllEntities = () => {
    if (filters.accountableId) {
      dispatch(
        getEntities(filters.accountableId),
      );
    }
  };

  const handleChange = (pageNumber: number, size: number, sorter: any) => {
    setPaginationState({
      ...paginationState,
      order: DESC,
      sort: sorter.columnKey,
      activePage: pageNumber,
      itemsPerPage: size,
    });
  };

  const handleWarningDeleteItem = (item: any) => {
    setVisibleConfirmDelete(true);
    setItemSelected(item);
  };

  const handleConfirmDelete = () => {
    if (itemSelected) {
      dispatch(deleteEntity(itemSelected.id))
        .then(() => {
          if (selectedPlanPeriod === 3) {
            dispatch(getAdjustmentConfigure({ ownerid: filters?.accountableId, planPeriodId: planPeriodIdSelected }));
          } else {
            dispatch(getApproveConfigure({ ownerid: filters?.accountableId, planPeriodId: planPeriodIdSelected }));
          }
        })
        .finally(() => {
          setVisibleConfirmDelete(false);
        });
    }
  };

  const handleFreeTextSearchQuery = query => {
    dispatch(setListFilterApprovalLevel({ ...filters, searchText: query }))
  };

  const handleChangePlanPeriod = (value: string) => {
    setPlanPeriodIdSelected(value);
    const detailPlanPeriod = _.find(planPeriodList, o => o.id === value);
    if (detailPlanPeriod) {
      dispatch(
        setListFilterApprovalLevel({
          ...filters,
          planPeriodName: detailPlanPeriod.name,
          planPeriodId: value,
          planPeriodType: detailPlanPeriod.planPeriodType,
        }),
      );
    }
  };

  const handleOpenForm = (item = undefined) => {
    setOpenForm(true);
    setItemSelected(item)
  };

  const handleCloseModalForm = (isReload = false) => {
    setOpenForm(false);
    setItemSelected(null);
    // Không reset khi đóng modal form edit, chỉ reset khi đóng modal chính

    if (isReload) {
      // getAllEntities();
    }
  };

  const handleCloseModal = () => {
    // Reset khi đóng modal chính
    dispatch(reset());
    dispatch(setListFilterApprovalLevel(null))
    onClose()
  }

  const handleFetCurrentStatusProcess = () => {
    dispatch(getCurrentStatusProcess({ ownerId: filters?.accountableId, year: filters?.year, planPeriodId: filters?.planPeriodId }));
  }

  const handleFetCurrentStatusProcessAdjustment = () => {
    dispatch(getCurrentStatusProcessAdjustment({ ownerId: filters?.accountableId, year: filters?.year, planPeriodId: filters?.planPeriodId }));
  }

  const handleFormValuesChange = (changedValues, allValues) => {
    if (allValues.selectPlan && allValues.selectedPeriod) {
      setIsDisabledAdd(true);
      if (allValues.selectedPeriod === 3) {
        dispatch(getAdjustmentConfigure({ ownerid: filters?.accountableId, planPeriodId: allValues.selectPlan }));
        setSelectedPlanPeriod(allValues.selectedPeriod);
        dispatch(getTypeSelectboxApprovalLevel())
        handleFetCurrentStatusProcessAdjustment()
      }

      if (allValues.selectedPeriod === 2) {
        dispatch(getApproveConfigure({ ownerid: filters?.accountableId, planPeriodId: allValues.selectPlan }));
        setSelectedPlanPeriod(allValues.selectedPeriod);
        handleFetCurrentStatusProcess()
      }

      return
    }
  };

  useEffect(() => {
    dispatch(getTypeSelectboxApprovalLevel())
  }, []);


  return (
    <Modal open={isOpen} maskClosable={false} footer={null} onCancel={handleCloseModal} width={'80vw'} className='view'>
      <div className="d-flex gap-5">
        <Title level={3}>{`Thiết lập cấp phê duyệt ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
      </div>
      <div className="table">
        <div className="header">
          <Col md={18}>
            <Row className='w-100'>
              <Col md={18}>
                <Search size="large" allowClear placeholder="Nhập giá trị tìm kiếm" onSearch={handleFreeTextSearchQuery} enterButton />
              </Col>
            </Row>
          </Col>
          <Col md={6}>

            <Row className='w-100 justify-content-end'>
              {
                (form.getFieldValue('selectedPeriod') === 3
                  ? Object.keys(currentStatusProcessAdjustment).length === 0
                  : form.getFieldValue('selectedPeriod') === 2
                    ? Object.keys(currentStatusProcess).length === 0
                    : false
                ) && (
                  <Button size="large" onClick={handleOpenForm} className="primary" disabled={!isDisabledAdd}>
                    <PlusOutlined /> Thêm mới
                  </Button>
                )
              }
            </Row>
          </Col>
        </div>
        <Row className='w-100'>
          <Col md={12}>
            <Form
              form={form}
              layout="vertical"
              onValuesChange={handleFormValuesChange}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Kì kế hoạch" name={"selectPlan"} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                    <Select className="w-100" size="large" placeholder="Chức năng" onChange={handleChangePlanPeriod} filterOption={filterOption} options={planPeriodList.map(x => ({ label: x.name, value: x.id }))} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label="Loại quy trình" name={'selectedPeriod'} rules={[{ required: true, message: "Vui lòng nhập phiên bản quy trình" }]}>
                    <Select className="w-100" size="large" placeholder="Chức năng" filterOption={filterOption} options={typeSelectboxData.map(x => ({ label: x.label, value: x.value }))} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <TableComponent
          data={adjustmentConfigure.map((x, index) => {
            return {
              key: index + 1,
              ...x,
            };
          })}
          scroll={false}
          noPagination={true}
          isFetching={loadingAdjustmentConfigure || loadingApproveConfigure}
          columns={newColumns}
          handlePageChange={(pageNumber: number, size: number, search: any, sorter: any) => {
            handleChange(pageNumber, size, sorter);
          }}
        />
      </div>
      {isOpenForm && <ApprovalLevelUpdate isOpen={isOpenForm} onClose={handleCloseModalForm} idItemSelected={itemSelected?.id} selectedPlanPeriod={selectedPlanPeriod} />}
      <ModalConfirmComponent
        visible={visibleConfirmDelete}
        onCancel={() => {
          setVisibleConfirmDelete(false);
        }}
        isLoading={isDeleting}
        onConfirm={handleConfirmDelete}
        title={`Bạn có muốn xóa thiết lập ${itemSelected?.name}`}
      />
    </Modal>
  );
};

export default ApprovalLevel;
